import classNames from 'classnames'

import s from './ApplyFormLabel.module.css'

//TODO: setup proptypes
function ApplyFormLabel({ errors = [], attr, attrs, label }) {
  const hasError = attrs
    ? attrs.filter((a) => errors.includes(a.attr || a)).length !== 0
    : errors.includes(attr.attr || attr)

  const errorLabel = () => {
    const errorAttr = attrs
      ? attrs.find((a) => errors.includes(a.attr || a))
      : attr
    if (errorAttr.label) return errorAttr.label

    return errorAttr
  }

  const idTarget = attrs ? attrs[0] : attr
  return (
    <label
      className={classNames(s.container, { [s.error]: hasError })}
      htmlFor={idTarget.attr || idTarget}
    >
      {hasError ? `A valid ${errorLabel()} is required` : label}
    </label>
  )
}

export default ApplyFormLabel
